import Swiper, { Navigation } from 'swiper';
import "swiper/scss";

const iconText = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const swiper = new Swiper('.icon-text__swiper-container', {
            modules: [Navigation],
            centeredSlides: true,
            loop: true,
            navigation: {
                nextEl: "[data-icon-text-swiper-next]",
                prevEl: "[data-icon-text-swiper-prev]",
            }
        });
        swiper.on('slideChange', () => {
            const index = swiper.realIndex;
            const slides = document.querySelectorAll('[data-icon-slide-index]');
            const slideCount = slides.length;
            slides.forEach((slide) => {
                const slideElement: HTMLElement = slide as HTMLElement;
                slideElement.classList.remove('active', 'active-next', 'active-prev');
                const slideIndexText = slideElement.dataset.iconSlideIndex;
                let slideIndex = -1;
                if(slideIndexText){
                    slideIndex = parseInt(slideIndexText);
                }
                if(slideIndex !== -1) { 
                    if(slideIndex === index) {
                        slideElement.classList.add('active');
                    } else if(slideIndex === ((index + 1) % slideCount)) {
                        slideElement.classList.add('active-next');
                    } else if(slideIndex === ((index - 1 + slideCount) % slideCount)) {
                        slideElement.classList.add('active-prev');
                    }
                }
            });
        });
        document.querySelectorAll('[data-icon-slide-index]').forEach((slideButton) => {
            const slideButtonElement = slideButton as HTMLElement;
            slideButtonElement.addEventListener('click', () => {
                const dataIndex = slideButtonElement.dataset.iconSlideIndex;
                if(dataIndex) {
                    const index = parseInt(dataIndex);
                    const slideIndex = swiper.realIndex;
                    const slides = document.querySelectorAll('[data-icon-slide-index]');
                    const slideCount = slides.length;
                    if(slideIndex === ((index - 1 + slideCount) % slideCount)) {
                        swiper.slideNext();
                    } else if(slideIndex === ((index + 1) % slideCount)) {
                        swiper.slidePrev();
                    }
                }
            });
        });
    });
}

export { iconText }